export default __webpack_public_path__ + "static/media/icon_plin.cbd6e9aa.svg";